// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__YctiP","content":"LoadingAlert_content__2o8Yi"};